import React, { useEffect, useState } from "react";
import logo from "./icon.png";
import "./App.css";
import { isAndroid, isIOS } from "react-device-detect";
import { Route, Routes, useLocation } from "react-router-dom";
// import { usePageVisibility } from "react-page-visibility";

function App() {
  return (
    <Routes>
      <Route path="/*" element={<AppRouter />} />
    </Routes>
  );
}

function AppRouter() {
  const { pathname, search } = useLocation();
  const deeplinkQuery = pathname.slice(1) + search;
  // const isVisible = usePageVisibility();
  // const [timeover, setTimeover] = useState<boolean>(false);

  useEffect(() => {
    let pageUrl = "merakiyourdoctor://";
    if (deeplinkQuery) pageUrl += deeplinkQuery;

    if (isAndroid) {
      window.location.replace(pageUrl);
      setTimeout(() => {
        window.location.replace(
          "https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.merakiplace.mydoctor"
        );
      }, 250);
    } else if (isIOS) {
      window.location.replace(pageUrl);
      setTimeout(() => {
        window.location.href =
          "https://apps.apple.com/us/app/나만의닥터/id1584940053";
        // setTimeover(true);
      }, 700);
    } else {
      window.location.href = "https://my-doctor.io";
    }
  }, [deeplinkQuery]);

  // useEffect(() => {
  //   if (isVisible && timeover) {
  //     window.location.href =
  //       "https://apps.apple.com/us/app/나만의닥터/id1584940053";
  //     setTimeover(false);
  //   }
  // }, [isVisible, timeover]);

  return (
    <>
      <div className="App">
        <header className="App-header">
          <img
            src={logo}
            className="App-logo"
            alt="logo"
            onClick={() => (window.location.href = "https://my-doctor.io")}
          />
          <div>
            <span className="App-description">No.1 비대면 진료 & 약 배송</span>
          </div>
          <div>
            <span className="App-name">나만의닥터</span>
          </div>
          <div>
            <img
              src={"appstore.png"}
              className="Store-button"
              alt="logo"
              onClick={() =>
                (window.location.href =
                  "https://apps.apple.com/us/app/나만의닥터/id1584940053")
              }
            />
            <img
              src={"googleplay.png"}
              className="Store-button"
              alt="logo"
              onClick={() =>
                window.location.replace(
                  "https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.merakiplace.mydoctor"
                )
              }
            />
          </div>
        </header>
      </div>
    </>
  );
}

export default App;
